module.exports = __webpack_public_path__ + "static/media/followthesun.4f07ddeb.jpg";